import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import StarsSvg from 'images/v5/icons/stars-01.svg';
import Button from 'layout/atoms/Button/Button';
import TabsButton from 'layout/atoms/TabsButton/TabsButton';
import Grid from 'layout/molecules/Grid/Grid';
import { clearBreadcrumbs, openHelpAgent, setBreadcrumbs } from 'store/layoutSlice';
import Dashboard from 'templates/Dashboard/Dashboard';
import Brands from './Brands/Brands';
import Categories from './Categories/Categories';
import ExchangeRates from './ExchangeRates/ExchangeRates';
import Maintenance from './Maintenance/Maintenance';
import ModelDimensions from './ModelDimensions/ModelDimensions';
import ProductCategories from './ProductCategories/ProductCategories';
import ProductParameters from './ProductParameters/ProductParameters';
import Seasons from './Seasons/Seasons';
import Sizes from './Sizes/Sizes';
import Statuses from './Statuses/Statuses';
function SpecificationParametersDashboard() {
    const { t } = useTranslation(['specification', 'common', 'layout']);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const path = `/specification-parameters`;
    const [activeTab, setActiveTab] = useState('brands');
    useEffect(() => {
        dispatch(setBreadcrumbs([
            { to: '/specification-parameters', name: t('common:SIDEBAR_MENU_ADMINISTRATION') },
        ]));
        return () => {
            dispatch(clearBreadcrumbs());
        };
    }, [dispatch, t]);
    useEffect(() => {
        const tab = location.pathname.replace(`${path}/`, '');
        setActiveTab(tab || 'brands');
    }, [location.pathname, path]);
    const tabs = [
        {
            id: 'brands',
            label: t('brands'),
        },
        {
            id: 'categories',
            label: t('common:categories'),
        },
        {
            id: 'product',
            label: t('product_parameters'),
        },
        {
            id: 'product-category',
            label: t('product_categories'),
        },
        {
            id: 'seasons',
            label: t('seasons'),
        },
        {
            id: 'statuses',
            label: t('statuses'),
        },
        {
            id: 'sizes',
            label: t('sizes'),
        },
        {
            id: 'dimensions',
            label: t('model_dimensions'),
        },
        {
            id: 'exchange-rates',
            label: t('common:exchange_rates'),
        },
        {
            id: 'maintenance',
            label: t('common:maintenance'),
        },
    ];
    return (React.createElement(Dashboard, { headerAside: React.createElement(Button, { color: "inverse", shape: "squared", leftIcon: React.createElement(StarsSvg, null), onClick: () => dispatch(openHelpAgent()) }) },
        React.createElement(Grid, { vp: 12, hp: 24 },
            React.createElement(TabsButton, { activeTab: activeTab, tabs: tabs, onClick: (e) => navigate(`${path}/${e}`) }),
            React.createElement(Grid, { gap: 0 },
                React.createElement(Routes, null,
                    React.createElement(Route, { path: "brands", element: React.createElement(Brands, null) }),
                    React.createElement(Route, { path: "categories", element: React.createElement(Categories, null) }),
                    React.createElement(Route, { path: "product", element: React.createElement(ProductParameters, null) }),
                    React.createElement(Route, { path: "product-category", element: React.createElement(ProductCategories, null) }),
                    React.createElement(Route, { path: "seasons", element: React.createElement(Seasons, null) }),
                    React.createElement(Route, { path: "statuses", element: React.createElement(Statuses, null) }),
                    React.createElement(Route, { path: "sizes", element: React.createElement(Sizes, null) }),
                    React.createElement(Route, { path: "dimensions", element: React.createElement(ModelDimensions, null) }),
                    React.createElement(Route, { path: "exchange-rates", element: React.createElement(ExchangeRates, null) }),
                    React.createElement(Route, { path: "maintenance", element: React.createElement(Maintenance, null) }),
                    React.createElement(Route, { index: true, element: React.createElement(Navigate, { to: "brands", replace: true }) }))))));
}
export default memo(SpecificationParametersDashboard);
